import React, { forwardRef } from 'react';

import { t } from '@/utils/helper/intl';

import SuccessIcon from './icon/success';

export interface UploadSuccessProps {
  url: string;
  file: File;
  slotNode?: (url: string, file: File, onClear: () => void) => React.ReactNode;
  onClear: () => void;
  onSuccess?: (url: string, file: File, arg?: any) => void;
}

const UploadSuccess = forwardRef<HTMLDivElement, UploadSuccessProps>(
  (props, ref): React.ReactNode => {
    const { slotNode, url, file, onClear } = props;

    return (
      <div ref={ref} className={`wrapper-upload-step w-full h-full`}>
        {slotNode ? (
          slotNode(url, file, onClear)
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center">
            <SuccessIcon />
            <p className="text-center text-[#1FDF2C] text-[17px] leading-[20px] tracking-[0.383px] font-medium pt-[12px]">
              {t('merror.tip.uploadSuccess')}
            </p>
          </div>
        )}
      </div>
    );
  },
);

export default UploadSuccess;
